import { Directive, ElementRef, Input, SimpleChanges, OnInit } from '@angular/core';

@Directive({
    selector: '[MathJax]'
})
export class MathJaxDirective {
    @Input('MathJax') fractionString: string;
    @Input('MathJax') Question_Text: string;
    @Input('MathJax') Question_Text1: string;
    sss: any;
    constructor( private el: ElementRef) { }
    mathJaxObject;

    ngOnChanges() {




        //this.el.nativeElement.style.backgroundColor = 'yellow';
        MathJax.Hub.Config({
            showMathMenu: false,
            tex2jax: { inlineMath: [['$', '$'], ['\\(', '\\)']] },
            menuSettings: { zoom: "Double-Click", zscale: "150%" },
            CommonHTML: { linebreaks: { automatic: true } },
            "HTML-CSS": { linebreaks: { automatic: true }},
            SVG: { linebreaks: { automatic: true } }
        });
        this.el.nativeElement.innerHTML = this.Question_Text;
        setTimeout(() => {
            //MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("Question_Text")]);
            MathJax.Hub.Queue(["Typeset", MathJax.Hub, this.el.nativeElement]);
            MathJax.Hub.Queue(["Typeset", MathJax.Hub, document.getElementsByClassName("answers")]);
        }, 50)



    }

    // ngOnChanges(changes: SimpleChanges) {
    //
    //     if (changes['MathJax']) {
    //
    //         this.renderMath()
    //     }
    // }
    // renderMath() {
    //
    //     // MathJax.Hub.Queue(["Typeset",MathJax.Hub]);
    //
    //
    //     this.mathJaxObject = this.gs.nativeGlobal()['MathJax'];
    //     //setInterval(()=>{},1)
    //     let angObj = this;
    //     setTimeout(() => {
    //
    //         angObj.mathJaxObject.Hub.Queue(["Typeset", angObj.mathJaxObject.Hub], 'Question_Text');
    //         angObj.mathJaxObject.Hub.Queue(["Typeset", angObj.mathJaxObject.Hub], 'Question_Text1');

    //     }, 5000)
    //
    //
    // }
    // loadMathConfig() {
    //
    //
    //
    //     this.mathJaxObject = this.gs.nativeGlobal()['MathJax'];
    //     this.mathJaxObject.Hub.Config({
    //         showMathMenu: false,
    //         tex2jax: { inlineMath: [["$", "$"], ["\\(", "\\)"]] },
    //         menuSettings: { zoom: "Double-Click", zscale: "150%" },
    //         CommonHTML: { linebreaks: { automatic: true } },
    //         "HTML-CSS": { linebreaks: { automatic: true } },
    //         SVG: { linebreaks: { automatic: true } }
    //     });
    // }
    // ngOnInit() {

    //     this.loadMathConfig()
    //     this.renderMath();

    // }
}